var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0185 2.66751C7.98437 2.66751 5.51854 5.13334 5.51854 8.16751V10.8167C5.51854 11.3758 5.2802 12.2283 4.99604 12.705L3.94187 14.4558C3.29104 15.5375 3.7402 16.7383 4.93187 17.1417C8.8827 18.4617 13.1452 18.4617 17.096 17.1417C18.2052 16.775 18.691 15.4642 18.086 14.4558L17.0319 12.705C16.7569 12.2283 16.5185 11.3758 16.5185 10.8167V8.16751C16.5185 5.14251 14.0435 2.66751 11.0185 2.66751Z",
    stroke: "#8D8E94",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 2.93334C12.4298 2.85084 12.1364 2.78667 11.8339 2.75C10.9539 2.64 10.1106 2.70417 9.32227 2.93334C9.5881 2.255 10.2481 1.77834 11.0181 1.77834C11.7881 1.77834 12.4481 2.255 12.7139 2.93334Z",
    stroke: "#8D8E94",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7686 17.4717C13.7686 18.9842 12.5311 20.2217 11.0186 20.2217C10.2669 20.2217 9.57022 19.91 9.07522 19.415C8.58022 18.92 8.26855 18.2233 8.26855 17.4717",
    stroke: "#8D8E94",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5edb5b802e86445ad6b37d8482eb3476.svg";
export { ForwardRef as ReactComponent };